<template>
  <v-card>
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Columnas Estimados de Venta</div>
      <div>
        <v-tabs v-model="currentTab">
          <v-tab :disabled="editMode === 'edit' || editMode === 'new'">
            Lista
          </v-tab>
          <v-tab :disabled="!currentItem">Detalle</v-tab>
        </v-tabs>
      </div>
      <div v-show="currentTab === 1">
        <v-btn color="warning" outlined @click="cancel" class="mx-2">
          Cancelar
        </v-btn>
        <v-btn
          v-show="editMode === 'show' && canEditCurrent"
          color="success"
          outlined
          @click="edit"
          class="mx-2"
        >
          Editar
        </v-btn>
        <v-btn
          v-show="editMode !== 'show'"
          color="success"
          outlined
          @click="save"
          clss="mx-2"
        >
          Guardar
        </v-btn>
      </div>
    </v-card>

    <v-card-text v-if="currentTab === 0">
      <paginated-search-table
        endpoint="/data/campaigns"
        ordering="-code"
        filterString="current=true"
        searchLabel=""
        :headers="tableHeaders"
        :canEdit="true"
        :canAdd="false"
        :showSearch="false"
        @itemSelected="itemSelected($event, false)"
        @editItem="itemSelected($event, true)"
        @add="addNew"
      ></paginated-search-table>
    </v-card-text>

    <div v-if="currentTab === 1">
      <estimation-column-edit
        :value="currentItem.id"
        :title="currentItem.description"
        :initialmode="editMode"
        :key="currentTab"
        @endEdit="endEdit"
        @modeChange="editModeChange($event)"
        ref="itemEdit"
      ></estimation-column-edit>
    </div>
  </v-card>
</template>
<script>
import PaginatedSearchTable from "@/components/PaginatedSearchTable.vue";
import EstimationColumnEdit from "@/components/EstimationColumnEdit.vue";

export default {
  name: "EstimationColumn",

  components: {
    PaginatedSearchTable,
    EstimationColumnEdit
  },

  data: () => ({
    currentTab: 0,
    currentItem: null,
    canEditCurrent: false,
    editMode: null,
    tableHeaders: [
      { text: "Codigo", value: "code", sortable: false },
      { text: "Descripción", value: "description", sortable: false },
      { text: "Acciones", value: "actions", sortable: false }
    ]
  }),

  methods: {
    itemSelected(args, edit) {
      // eslint-disable-next-line
      this.canEditCurrent = !((args.user_id ? args.user_id : -1) === this.$bRoot.appInfo.user_id)
      if (!this.canEditCurrent) {
        edit = false;
      }
      this.editMode = edit ? "edit" : "show";
      this.currentItem = args;
      this.currentTab = 1;
    },

    addNew() {
      this.currentItem = null;
      this.editMode = "new";
      this.currentTab = 1;
    },

    async cancel() {
      // eslint-disable-next-line
      if(this.editMode === 'show' || await this.$confirm("Confirme que desea abandonar la edición, los datos modificados se perderán")) {
        this.endEdit();
      }
    },

    save() {
      this.$refs.itemEdit.save();
    },

    edit() {
      if (this.currentItem && this.currentTab === 1) {
        this.editMode = "edit";
        this.$refs.itemEdit.mode = "edit";
        this.$refs.itemEdit.editing = true;
      }
    },

    endEdit() {
      this.editMode = null;
      this.currentItem = null;
      this.error = null;
      this.currentTab = 0;
    },

    editModeChange(mode) {
      this.editMode = mode;
    }
  },

  mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    this.$bRoot.errors = null;
  }
};
</script>
